import { Button, Spacing, Text } from '@vkontakte/vkui';
import { ReactComponent as NoFileIcon } from 'img/no-file.svg';
import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendAllDocumentsUnlockRequest } from 'reactApp/modules/allDocuments/allDocuments.module';
import { getAllDocumentsAccessRequestSent } from 'reactApp/modules/allDocuments/allDocuments.selectors';
import { closePopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';

import styles from './AllDocumentsRequestModal.css';

export const AllDocumentsRequestModal = memo(() => {
    const dispatch = useDispatch();

    const isRequestSent = useSelector(getAllDocumentsAccessRequestSent);

    const handleSendAllDocsUnlockRequest = useCallback(() => {
        dispatch(sendAllDocumentsUnlockRequest());
    }, [dispatch]);

    const onClose = useCallback(() => {
        closePopupHelper(popupNames.ALL_DOCUMENTS_REQUEST_MODAL);
    }, []);

    const onSendRequestClick = () => {
        handleSendAllDocsUnlockRequest();
    };

    useEffect(() => {
        if (isRequestSent) {
            closePopupHelper(popupNames.ALL_DOCUMENTS_REQUEST_MODAL);
        }
    }, [isRequestSent]);

    return (
        <Dialog
            open
            id="alldoc-request-dialog"
            className={styles.dialog}
            closeIconWrapperClassName={styles.closeButton}
            closeIconClassName={styles.closeIcon}
            onCancel={onClose}
        >
            <div className={styles.top}>
                <NoFileIcon />
            </div>
            <div className={styles.bottom}>
                <Text className={styles.heading} data-qa-id="alldoc-request-header">
                    Работа с документами
                    <br />
                    не доступна на вашем тарифе
                </Text>
                <Spacing size={12} />
                <Text data-qa-id="alldoc-request-message">
                    Чтобы получить доступ к созданию, редактированию и совместной работе
                    <br />с документами, запросите изменение на платный тариф VK Workspace у администратора
                </Text>
                <Spacing size={24} />
                <Button
                    data-qa-id="alldoc-request-button"
                    size="m"
                    mode="primary"
                    appearance="accent-invariable"
                    onClick={onSendRequestClick}
                >
                    Запросить изменение тарифа
                </Button>
            </div>
        </Dialog>
    );
});

AllDocumentsRequestModal.displayName = 'AllDocumentsRequestModal';
